// Healthcare color palette
export const colors = {
  // Primary colors
  primary: '#2B84C4',
  secondary: '#41B6A6',
  
  // Text colors
  textPrimary: '#2C3E50',
  textSecondary: '#5D7285',
  
  // Background colors
  lightPrimary: '#EBF5FC',
  lightSecondary: '#E8F6F4',
  
  // Status colors
  success: '#2D8A6B',
  warning: '#E9730F',
  error: '#D64242',
  
  // Gradients
  primaryGradient: 'linear-gradient(135deg, #2B84C4 0%, #41B6A6 100%)',
  
  // Additional colors
  border: '#E1E8ED',
  background: '#FFFFFF',
  backgroundSecondary: '#F8FAFC',
};

// Ant Design theme configuration
export const antThemeTokens = {
  token: {
    // Colors
    colorPrimary: colors.primary,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.error,
    colorInfo: colors.primary,
    
    // Text colors
    colorText: colors.textPrimary,
    colorTextSecondary: colors.textSecondary,
    
    // Border colors
    colorBorder: colors.border,
    
    // Background colors
    colorBgContainer: colors.background,
    colorBgElevated: colors.background,
    colorBgLayout: colors.backgroundSecondary,
    
    // Font
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    
    // Border radius
    borderRadius: 8,
    borderRadiusLG: 12,
    
    // Shadows
    boxShadow: '0 2px 8px rgba(43, 132, 196, 0.1)',
    boxShadowSecondary: '0 4px 16px rgba(43, 132, 196, 0.15)',
    
    // Component specific
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      paddingContentHorizontal: 24,
    },
    Card: {
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(43, 132, 196, 0.1)',
    },
    Input: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Select: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Modal: {
      borderRadius: 12,
      paddingContentHorizontalLG: 32,
    },
    Drawer: {
      borderRadius: 12,
    },
  },
};

// CSS variables for use in styled-components or CSS
export const cssVariables = `
  :root {
    --primary: ${colors.primary};
    --secondary: ${colors.secondary};
    --text-primary: ${colors.textPrimary};
    --text-secondary: ${colors.textSecondary};
    --light-primary: ${colors.lightPrimary};
    --light-secondary: ${colors.lightSecondary};
    --success: ${colors.success};
    --warning: ${colors.warning};
    --error: ${colors.error};
    --border: ${colors.border};
    --background: ${colors.background};
    --background-secondary: ${colors.backgroundSecondary};
    --gradient-primary: ${colors.primaryGradient};
  }
`; 